import CircularProgress from "@material-ui/core/CircularProgress"
import React, { memo } from "react"
import { StyledLoadingContainer } from "./style"

function LoadingIndicator() {
  return (
    <>
      <StyledLoadingContainer>
        <CircularProgress color="primary" />
      </StyledLoadingContainer>
    </>
  )
}

export default memo(LoadingIndicator)
